import {Operation} from 'fast-json-patch';
import {StoreName} from '@/libs/core/store/store-name';

export enum ObjectChangeType {
    ObjectAdded = 'ObjectAdded',
    ObjectUpdated = 'ObjectUpdated',
    ObjectDeleted = 'ObjectDeleted',
}

export interface ObjectChangeEvent {
    correlationId: string,
    objectType: StoreName,
    objectId: string,
    eventType: ObjectChangeType,
    diff: Operation[],
    command?: string,
    relations: EnumDictionary<StoreName | string, string>
}
